export default {
  title: {
    en: 'Forgot your password?',
  },
}
